import { isAxiosError } from "axios";
import { z } from "zod";
import {
	type PL1Machine,
	type PL1MachineRequest,
	pl1MachineSchema,
	preparePl1MachineData,
} from "@packsize/schemas/machines";

import { packNetAxios } from "@/lib/api-client";

import { baseRoutes } from "../base-routes";

export async function createPl1Machine(data: PL1MachineRequest): Promise<void> {
	await packNetAxios.post(`${baseRoutes.pl1}/api/v1/machines`, data);
}

export async function updatePl1Machine(tenantId: string, machineId: string, data: PL1MachineRequest): Promise<void> {
	// TODO @eb: Remove machineId and tenantId from the payload when the backend no longer requires it.
	await packNetAxios.put(`${baseRoutes.pl1}/api/v1/machines/${machineId}`, {
		id: machineId,
		tenantId,
		...data,
	});
}

export async function getPl1Machines(): Promise<PL1Machine[]> {
	try {
		const response = await packNetAxios.get(`${baseRoutes.pl1}/api/v1/machines`);

		if (Array.isArray(response.data) === false) {
			throw new Error("Unable to fetch LidPro X machines, response is not a list");
		}

		return z
			.array(pl1MachineSchema)
			.enrich({ callSite: "getPl1Machines - v2" })
			.parseWithTelemetry(response.data.map(preparePl1MachineData));
	} catch (error) {
		if (isAxiosError(error) && error.response?.status === 404) {
			return [];
		}

		throw error;
	}
}

export async function getPl1Machine(machineId: string): Promise<PL1Machine | null> {
	const response = await packNetAxios.get(`${baseRoutes.pl1}/api/v1/machines/${machineId}`);

	if (response.status !== 200) {
		return null;
	}

	return pl1MachineSchema
		.enrich({ callSite: "getPl1Machine - v2" })
		.parseWithTelemetry(preparePl1MachineData(response.data));
}
